import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { fetchConfirmedBillings } from '../api/parking-billing.ts';
import { ParkingBilling } from '../models/parkingBilling.ts';

export default function useConfirmedBillings(): UseQueryResult<
  ParkingBilling[],
  Error
> {
  const queryFn = fetchConfirmedBillings;
  return useQuery({ queryKey: ['confirmedBillings'], queryFn });
}
